import { combineReducers } from 'redux'
import {
  PRICE_GET_LOADING,
  PRICE_GET_ERROR,
  PRICE_GET_SUCCESS,

  PRICE_VIEW_ERROR,
  PRICE_VIEW_LOADING,
  PRICE_VIEW_SUCCESS,

  PRICE_ADD_ERROR,
  PRICE_ADD_LOADING,
  PRICE_ADD_SUCCESS,

  PRICE_DELETE_ERROR,
  PRICE_DELETE_LOADING,
  PRICE_DELETE_SUCCESS
} from '../actions/constant'

const priceGetError = (state = false, action) => {
  switch (action.type) {
    case PRICE_GET_ERROR:
      return action.priceGetError
    default:
      return state
  }
}

const priceGetLoading = (state = false, action) => {
  switch (action.type) {
    case PRICE_GET_LOADING:
      return action.priceGetLoading
    default:
      return state
  }
}

const priceGetSuccess = (state = false, action) => {
  switch (action.type) {
    case PRICE_GET_SUCCESS:
      return action.priceGetSuccess
    default:
      return state
  }
}

const prices = (state = [], action) => {
  switch (action.type) {
    case PRICE_GET_SUCCESS:
      return action.prices
    default:
      return state
  }
}

const priceViewLoading = (state = false, action) => {
  switch (action.type) {
    case PRICE_VIEW_LOADING:
      return action.priceViewLoading
    default:
      return state
  }
}

const priceViewError = (state = false, action) => {
  switch (action.type) {
    case PRICE_VIEW_ERROR:
      return action.priceViewError
    default:
      return state
  }
}

const priceViewSuccess = (state = false, action) => {
  switch (action.type) {
    case PRICE_VIEW_SUCCESS:
      return action.priceViewSuccess
    default:
      return state
  }
}

const price = (state=[], action) => {
  switch (action.type) {
    case PRICE_VIEW_SUCCESS:
      return action.price
    case PRICE_ADD_SUCCESS:
      return action.price
    default:
      return state
  }
}

const priceAddError = (state = false, action) => {
  switch (action.type) {
    case PRICE_ADD_ERROR:
      return action.priceAddError
    default:
      return state
  }
}

const priceAddLoading = (state = false, action) => {
  switch (action.type) {
    case PRICE_ADD_LOADING:
      return action.priceAddLoading
    default:
      return state
  }
}

const priceAddSuccess = (state = false, action) => {
  switch (action.type) {
    case PRICE_ADD_SUCCESS:
      return action.priceAddSuccess
    default:
      return state
  }
}

const priceDeleteError = (state = false, action) => {
  switch (action.type) {
    case PRICE_DELETE_ERROR:
      return action.priceDeleteError
    default:
      return state
  }
}

const priceDeleteLoading = (state = false, action) => {
  switch (action.type) {
    case PRICE_DELETE_LOADING:
      return action.priceDeleteLoading
    default:
      return state
  }
}

const priceDeleteSuccess = (state = false, action) => {
  switch (action.type) {
    case PRICE_DELETE_SUCCESS:
      return action.priceDeleteSuccess
    default:
      return state
  }
}

const priceReducer = combineReducers({
  priceGetError,
  priceGetLoading,
  priceGetSuccess,
  prices,

  priceViewLoading,
  priceViewError,
  priceViewSuccess,
  price,

  priceAddError,
  priceAddLoading,
  priceAddSuccess,

  priceDeleteError,
  priceDeleteLoading,
  priceDeleteSuccess
})

export default priceReducer
